
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 13 10","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"icon-inner",attrs:{"d":"M6.12427 9.58984L0.831585 5.12831L6.12427 0.666769","stroke":"#222222"}}),_c('path',{staticClass:"icon-inner",attrs:{"d":"M0.830413 5.13379L12.1719 5.13379","stroke":"#222222"}})])
          )
        }
      }
    